import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AbstractControl, FormGroup} from '@angular/forms';
import {debounceTime, finalize, switchMap, take, tap} from 'rxjs/operators';
import {LocaleService} from '../../shared/localties.service';

@Injectable()
export class EditIdentityService {
  private _issuers$ = new BehaviorSubject<any[]>(undefined);
  readonly issuers$ = this._issuers$.asObservable();
  get issuers(): any[] { return this._issuers$.getValue(); }
  set issuers(value: any[]) { this._issuers$.next(value); }

  private _issuer$ = new BehaviorSubject<string>(undefined);
  readonly issuer$ = this._issuer$.asObservable();
  get issuer(): any { return this._issuer$.getValue(); }

  private _areLoadingIssuers$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingIssuers$ = this._areLoadingIssuers$.asObservable();
  set areLoadingIssuers(value: boolean) { this._areLoadingIssuers$.next(value); }

  private _issuerPage$ = new BehaviorSubject<number>(1);
  readonly issuerPage$ = this._issuerPage$.asObservable();
  get issuerPage(): number { return this._issuerPage$.getValue(); }
  set issuerPage(value: number) { this._issuerPage$.next(value); }

  private _canLoadMoreIssuer$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreIssuer$ = this._canLoadMoreIssuer$.asObservable();
  get canLoadMoreIssuer(): boolean { return this._canLoadMoreIssuer$.getValue(); }
  set canLoadMoreIssuer(value: boolean) { this._canLoadMoreIssuer$.next(value); }

  private _birthCountries$ = new BehaviorSubject<any[]>(undefined);
  readonly birthCountries$ = this._birthCountries$.asObservable();
  get birthCountries(): any[] { return this._birthCountries$.getValue(); }
  set birthCountries(value: any[]) { this._birthCountries$.next(value); }

  private _birthCountry$ = new BehaviorSubject<string>(undefined);
  readonly birthCountry$ = this._birthCountry$.asObservable();
  set birthCountry(value: string) { this._birthCountry$.next(value); }

  private _areLoadingBirthCountries$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingBirthCountries$ = this._areLoadingBirthCountries$.asObservable();
  set areLoadingBirthCountries(value: boolean) { this._areLoadingBirthCountries$.next(value); }

  private _birthCountryPage$ = new BehaviorSubject<number>(1);
  readonly birthCountryPage$ = this._birthCountryPage$.asObservable();
  get birthCountryPage(): number { return this._birthCountryPage$.getValue(); }
  set birthCountryPage(value: number) { this._birthCountryPage$.next(value); }

  private _canLoadMoreBirthCountry$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreBirthCountry$ = this._canLoadMoreBirthCountry$.asObservable();
  get canLoadMoreBirthCountry(): boolean { return this._canLoadMoreBirthCountry$.getValue(); }
  set canLoadMoreBirthCountry(value: boolean) { this._canLoadMoreBirthCountry$.next(value); }

  private _birthProvincies$ = new BehaviorSubject<any[]>(undefined);
  readonly birthProvincies$ = this._birthProvincies$.asObservable();
  get birthProvincies(): any[] { return this._birthProvincies$.getValue(); }
  set birthProvincies(value: any[]) { this._birthProvincies$.next(value); }

  private _birthProvince$ = new BehaviorSubject<string>(undefined);
  readonly birthProvince$ = this._birthProvince$.asObservable();
  get birthProvince(): string { return this._birthProvince$.getValue(); }
  set birthProvince(value: string) { this._birthProvince$.next(value); }

  private _areLoadingBirthProvincies$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingBirthProvincies$ = this._areLoadingBirthProvincies$.asObservable();
  set areLoadingBirthProvincies(value: boolean) { this._areLoadingBirthProvincies$.next(value); }

  private _birthProvincePage$ = new BehaviorSubject<number>(1);
  readonly birthProvincePage$ = this._birthProvincePage$.asObservable();
  get birthProvincePage(): number { return this._birthProvincePage$.getValue(); }
  set birthProvincePage(value: number) { this._birthProvincePage$.next(value); }

  private _canLoadMoreBirthProvince$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreBirthProvince$ = this._canLoadMoreBirthProvince$.asObservable();
  get canLoadMoreBirthProvince(): boolean { return this._canLoadMoreBirthProvince$.getValue(); }
  set canLoadMoreBirthProvince(value: boolean) { this._canLoadMoreBirthProvince$.next(value); }

  private _birthCities$ = new BehaviorSubject<any[]>(undefined);
  readonly birthCities$ = this._birthCities$.asObservable();
  get birthCities(): any[] { return this._birthCities$.getValue(); }
  set birthCities(value: any[]) { this._birthCities$.next(value); }

  private _birthCity$ = new BehaviorSubject<string>(undefined);
  readonly birthCity$ = this._birthCity$.asObservable();
  get birthCity(): string { return this._birthCity$.getValue(); }
  set birthCity(value: string) { this._birthCity$.next(value); }

  private _areLoadingBirthCities$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingBirthCities$ = this._areLoadingBirthCities$.asObservable();
  set areLoadingBirthCities(value: boolean) { this._areLoadingBirthCities$.next(value); }

  private _birthCityPage$ = new BehaviorSubject<number>(1);
  readonly birthCityPage$ = this._birthCityPage$.asObservable();
  get birthCityPage(): number { return this._birthCityPage$.getValue(); }
  set birthCityPage(value: number) { this._birthCityPage$.next(value); }

  private _canLoadMoreBirthCity$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreBirthCity$ = this._canLoadMoreBirthCity$.asObservable();
  get canLoadMoreBirthCity(): boolean { return this._canLoadMoreBirthCity$.getValue(); }
  set canLoadMoreBirthCity(value: boolean) { this._canLoadMoreBirthCity$.next(value); }

  private _countries$ = new BehaviorSubject<any[]>(undefined);
  readonly countries$ = this._countries$.asObservable();
  get countries(): any[] { return this._countries$.getValue(); }
  set countries(value: any[]) { this._countries$.next(value); }

  private _country$ = new BehaviorSubject<string>(undefined);
  readonly country$ = this._country$.asObservable();
  get country(): string { return this._country$.getValue(); }
  set country(value: string) { this._country$.next(value); }

  private _areLoadingCountries$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingCountries$ = this._areLoadingCountries$.asObservable();
  set areLoadingCountries(value: boolean) { this._areLoadingCountries$.next(value); }

  private _countryPage$ = new BehaviorSubject<number>(1);
  readonly countryPage$ = this._countryPage$.asObservable();
  get countryPage(): number { return this._countryPage$.getValue(); }
  set countryPage(value: number) { this._countryPage$.next(value); }

  private _canLoadMoreCountry$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreCountry$ = this._canLoadMoreCountry$.asObservable();
  get canLoadMoreCountry(): boolean { return this._canLoadMoreCountry$.getValue(); }
  set canLoadMoreCountry(value: boolean) { this._canLoadMoreCountry$.next(value); }

  private _provincies$ = new BehaviorSubject<any[]>(undefined);
  readonly provincies$ = this._provincies$.asObservable();
  get provincies(): any[] { return this._provincies$.getValue(); }
  set provincies(value: any[]) { this._provincies$.next(value); }

  private _province$ = new BehaviorSubject<string>(undefined);
  readonly province$ = this._province$.asObservable();
  get province(): string { return this._province$.getValue(); }
  set province(value: string) { this._province$.next(value); }

  private _areLoadingProvincies$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingProvincies$ = this._areLoadingProvincies$.asObservable();
  set areLoadingProvincies(value: boolean) { this._areLoadingProvincies$.next(value); }

  private _provincePage$ = new BehaviorSubject<number>(1);
  readonly provincePage$ = this._provincePage$.asObservable();
  get provincePage(): number { return this._provincePage$.getValue(); }
  set provincePage(value: number) { this._provincePage$.next(value); }

  private _canLoadMoreProvince$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreProvince$ = this._canLoadMoreProvince$.asObservable();
  get canLoadMoreProvince(): boolean { return this._canLoadMoreProvince$.getValue(); }
  set canLoadMoreProvince(value: boolean) { this._canLoadMoreProvince$.next(value); }

  private _cities$ = new BehaviorSubject<any[]>(undefined);
  readonly cities$ = this._cities$.asObservable();
  get cities(): any[] { return this._cities$.getValue(); }
  set cities(value: any[]) { this._cities$.next(value); }

  private _city$ = new BehaviorSubject<string>(undefined);
  readonly city$ = this._city$.asObservable();
  get city(): string { return this._city$.getValue(); }
  set city(value: string) { this._city$.next(value); }

  private _areLoadingCities$ = new BehaviorSubject<boolean>(false);
  readonly areLoadingCities$ = this._areLoadingCities$.asObservable();
  set areLoadingCities(value: boolean) { this._areLoadingCities$.next(value); }

  private _cityPage$ = new BehaviorSubject<number>(1);
  readonly cityPage$ = this._cityPage$.asObservable();
  get cityPage(): number { return this._cityPage$.getValue(); }
  set cityPage(value: number) { this._cityPage$.next(value); }

  private _canLoadMoreCity$ = new BehaviorSubject<boolean>(false);
  readonly canLoadMoreCity$ = this._canLoadMoreCity$.asObservable();
  get canLoadMoreCity(): boolean { return this._canLoadMoreCity$.getValue(); }
  set canLoadMoreCity(value: boolean) { this._canLoadMoreCity$.next(value); }

  constructor(
    private localeService: LocaleService
  ) { }

  onIssuerSearch(issuer: string): void {
    this._areLoadingIssuers$.next(true);
    this._issuer$.next(issuer);
  }

  onIssuerValueChange$(issuerTypeCtrl: AbstractControl): Observable<any> {
    return this.issuer$.pipe(
      debounceTime(700),
      tap(() => this.issuerPage = 1),
      switchMap(issuer => {
        const issuerType = issuerTypeCtrl.value;
        return this.localeService.lookUpNameDocument(issuer, issuerType, this.issuerPage).pipe(
          take(1),
          tap(response => {
            this.issuers = response?.results;
            this.canLoadMoreIssuer = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingIssuers = false)
        );
      })
    );
  }

  loadMoreIssuer(issuerType: string): void {
    if (!this.canLoadMoreIssuer) {
      return;
    }
    this._issuerPage$.next(this.issuerPage + 1);
    this.localeService.lookUpNameDocument(this.issuer, issuerType, this.issuerPage).pipe(
      take(1),
      tap(response => {
        this.issuers = [...this.issuers, ...response?.results];
        this.canLoadMoreIssuer = response?.pagination.more;
      })
    ).subscribe();
  }

  onCountryValueChange$(): Observable<any> {
    return this.country$.pipe(
      debounceTime(700),
      tap(() => this.countryPage = 1),
      switchMap(country => {
        return this.localeService.lookUpCountry(country, this.countryPage).pipe(
          take(1),
          tap(response => {
            this.countries = response?.results;
            this.canLoadMoreCountry = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingCountries = false)
        );
      })
    );
  }

  loadMoreCountries(): void {
    if (!this.canLoadMoreCountry) {
      return;
    }
    this._countryPage$.next(this.countryPage + 1);
    this.localeService.lookUpCountry(this.country, this.countryPage).pipe(
      take(1),
      tap(response => {
        this.countries = [...this.countries, ...response?.results];
        this.canLoadMoreCountry = response?.pagination.more;
      })
    ).subscribe();
  }

  onCountrySearch(country: string): void {
    this.areLoadingCountries = true;
    this.country = country;
    console.log("COUNTRY TO SEARCH: ", this.country)
  }

  onProvinceValueChange$(countryCtrl: AbstractControl): Observable<any> {
    return this.province$.pipe(
      debounceTime(700),
      tap(() => this.provincePage = 1),
      switchMap(province => {
        const country = countryCtrl.value;
        return this.localeService.lookUpProvinces(province, country, this.provincePage).pipe(
          take(1),
          tap(response => {
            this.provincies = response?.results;
            this.canLoadMoreProvince = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingProvincies = false)
        );
      })
    );
  }

  loadMoreProvincies(country: string): void {
    if (!this.canLoadMoreProvince) {
      return;
    }
    this.provincePage += 1;
    this.localeService.lookUpProvinces(this.province, country, this.provincePage).pipe(
      take(1),
      tap(response => {
        this.provincies = [...this.provincies, ...response?.results];
        this.canLoadMoreProvince = response?.pagination.more;
      })
    ).subscribe();
  }

  onProvinceSearch(province: string): void {
    this.areLoadingProvincies = true;
    this.province = province;
  }

  onCityValueChange$(countryCtrl: AbstractControl, provinceCtrl: AbstractControl): Observable<any> {
    return this.city$.pipe(
      debounceTime(700),
      tap(() => this.cityPage = 1),
      switchMap(city => {
        const country = countryCtrl.value;
        const province = provinceCtrl.value;
        return this.localeService.lookUpCities(city, country, province, this.provincePage).pipe(
          take(1),
          tap(response => {
            this.cities = response?.results;
            this.canLoadMoreCity = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingCities = false)
        );
      })
    );
  }

  loadMoreCities(country: string, province: string): void {
    if (!this.canLoadMoreCity) {
      return;
    }
    this.cityPage += 1;
    this.localeService.lookUpCities(this.city, country, province, this.cityPage).pipe(
      take(1),
      tap(response => {
        this.cities = [...this.cities, ...response?.results];
        this.canLoadMoreCity = response?.pagination.more;
      })
    ).subscribe();
  }

  onCitySearch(city: string): void {
    this.areLoadingCities = true;
    this.city = city;
  }

  onBirthCountryValueChange$(): Observable<any> {
    return this.birthCountry$.pipe(
      debounceTime(700),
      tap(() => this.birthCountryPage = 1),
      switchMap(birthCountry => {
        return this.localeService.lookUpCountry(birthCountry, this.birthCountryPage).pipe(
          take(1),
          tap(response => {
            this.birthCountries = response?.results;
            this.canLoadMoreBirthCountry = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingBirthCountries = false)
        );
      })
    );
  }

  loadMoreBirthCountries(): void {
    if (!this.canLoadMoreBirthCountry) {
      return;
    }
    this.birthCountryPage += 1;
    this.localeService.lookUpCountry(this.birthCountry, this.birthCountryPage).pipe(
      take(1),
      tap(response => {
        this.birthCountries = [...this.birthCountries, ...response?.results];
        this.canLoadMoreBirthCountry = response?.pagination.more;
      })
    ).subscribe();
  }

  onBirthCountrySearch(birthCountry: string): void {
    this.areLoadingBirthCountries = true;
    this.birthCountry = birthCountry;
  }

  onBirthProvinceValueChange$(birthCountryCtrl: AbstractControl): Observable<any> {
    return this.birthProvince$.pipe(
      debounceTime(700),
      tap(() => this.birthProvincePage = 1),
      switchMap(birthProvince => {
        const birthCountry = birthCountryCtrl.value;
        return this.localeService.lookUpProvinces(birthProvince, birthCountry, this.birthProvincePage).pipe(
          take(1),
          tap(response => {
            this.birthProvincies = response?.results;
            this.canLoadMoreBirthProvince = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingBirthProvincies = false)
        );
      })
    );
  }

  loadMoreBirthProvincies(birthCountry: string): void {
    if (!this.canLoadMoreBirthProvince) {
      return;
    }
    this.birthProvincePage += 1;
    this.localeService.lookUpProvinces(this.birthProvince, birthCountry, this.birthProvincePage).pipe(
      take(1),
      tap(response => {
        this.birthProvincies = [...this.birthProvincies, ...response?.results];
        this.canLoadMoreBirthProvince = response?.pagination.more;
      })
    ).subscribe();
  }

  onBirthProvinceSearch(birthProvince: string): void {
    this.areLoadingBirthProvincies = true;
    this.birthProvince = birthProvince;
  }

  onBirthCityValueChange$(birthCountryCtrl: AbstractControl, birthProvinceCtrl: AbstractControl): Observable<any> {
    return this.birthCity$.pipe(
      debounceTime(700),
      tap(() => this.birthCityPage = 1),
      switchMap(birthCity => {
        const birthCountry = birthCountryCtrl.value;
        const birthProvince = birthProvinceCtrl.value;
        return this.localeService.lookUpCities(birthCity, birthCountry, birthProvince, this.birthProvincePage).pipe(
          take(1),
          tap(response => {
            this.birthCities = response?.results;
            this.canLoadMoreBirthCity = response?.pagination?.more;
          }),
          finalize(() => this.areLoadingBirthCities = false)
        );
      })
    );
  }

  loadMoreBirthCities(birthCountry: string, birthProvince: string): void {
    if (!this.canLoadMoreBirthCity) {
      return;
    }
    this.birthCityPage += 1;
    this.localeService.lookUpCities(this.birthCity, birthCountry, birthProvince, this.birthCityPage).pipe(
      take(1),
      tap(response => {
        this.birthCities = [...this.birthCities, ...response?.results];
        this.canLoadMoreBirthCity = response?.pagination.more;
      })
    ).subscribe();
  }

  onBirthCitySearch(birthCity: string): void {
    this.areLoadingBirthCities = true;
    this.birthCity = birthCity;
  }
}
